import { computed } from 'vue';
import useAuthStore from '~/stores/auth';
import { LmsRouteNames } from '~/types/types';
import { useLmsNavigation } from '~/composables/useLmsNavigation';

export function useUserProfileMenu() {
   const authStore = useAuthStore();
   const { findNavItem, isNavItemVisible } = useLmsNavigation();

   const showProfileFeatures = computed(() => {
      return (
         !!authStore?.user?.site_settings?.enable_user_profile_features &&
         authStore?.user.site_settings.portal !== 'uspa'
      );
   });

   const profileNavigationItems = computed(() => {
      const items: Array<{
         label: string;
         icon: string;
         to: { name: string };
      }> = [];
      if (!showProfileFeatures.value) {
         return items;
      }
      items.push({
         label: 'User information',
         icon: 'pi pi-user-edit',
         to: {
            name: LmsRouteNames.profile,
         },
      });
      if (findNavItem('site_wide_subscription')) {
         items.push({
            label: 'Your subscriptions',
            icon: 'pi pi-credit-card',
            to: {
               name: LmsRouteNames.subscriptions,
            },
         });
      }
      if (findNavItem('premium_packages')) {
         items.push({
            label: 'Your premium packages',
            icon: 'pi pi-box',
            to: {
               name: LmsRouteNames.premiumPackages,
            },
         });
      }
      if (isNavItemVisible('memberships')) {
         items.push({
            label: 'Your memberships',
            icon: 'pi pi-id-card',
            to: {
               name: LmsRouteNames.memberships,
            },
         });
      }
      return items;
   });

   const adminMenuItem = computed(() => {
      if (!authStore?.user?.site_settings?.admin_url) {
         return null;
      }
      return {
         label: 'Admin',
         icon: 'pi pi-cog',
         url: authStore.user.site_settings.admin_url,
         target: '_blank',
      };
   });

   return {
      showProfileFeatures,
      profileNavigationItems,
      adminMenuItem,
   };
}
